let _window = null;

export const getWindow = () => _window;
export const setWindow = (win) => _window = win;
export const callWindow = callable => callable(_window);



// WEBPACK FOOTER //
// ./src/misc/window.js